/** Sesión de soporte abierta desde el panel admin (el API la fija a este comercio). */
export interface SupportSessionInfo {
    expiresAt: string;
    createdBy: string | null;
}

export const SUPPORT_SESSION_STORAGE_KEY = 'supportSession';

export function readSupportSession(): SupportSessionInfo | null {
    try {
        const raw = localStorage.getItem(SUPPORT_SESSION_STORAGE_KEY);
        if (!raw) return null;
        const info = JSON.parse(raw);
        if (!info?.expiresAt) return null;
        if (new Date(info.expiresAt).getTime() <= Date.now()) {
            clearSupportSession();
            return null;
        }
        return info;
    } catch {
        return null;
    }
}

export function storeSupportSession(info: SupportSessionInfo): void {
    localStorage.setItem(SUPPORT_SESSION_STORAGE_KEY, JSON.stringify(info));
}

export function clearSupportSession(): void {
    localStorage.removeItem(SUPPORT_SESSION_STORAGE_KEY);
}
